import { graphql } from '@/generated/gql';

export const BASE_CONTRACT_LIST_QUERY = graphql(/* GraphQL */ `
  query BaseContractList(
    $offset: Int
    $limit: Int
    $filter: JSON
    $order: [ContractSortOrder!]
    $skipExport: Boolean = false
  ) {
    contracts(offset: $offset, limit: $limit, filter: $filter, order: $order) {
      nodes {
        id
        externalId
        supplierId
        supplierName
        supplierExternalId
        supplierIndustry {
          id
          name
        }
        supplierEmployeeCount
        supplierLegalType {
          id
          name
        }
        supplierAddress {
          city
          street
          postalCode
          countryCode
        }

        contractReceivedProposalsCount
        contractAverageValueContribution
        contractActive
        contractCreationDate
        contractValidFrom
        contractValidTo
        contractProductCount
        contractProductList @skip(if: $skipExport) {
          id
          name
        }
        contractProductCategoryCount
        contractProductCategoryList @skip(if: $skipExport) {
          id
          name
        }
        contractServiceCount
        contractServiceList @skip(if: $skipExport) {
          id
          name
        }
        representativeCount
        representativeList @skip(if: $skipExport) {
          id
          name
        }
        orderVolume
        orderVolumeYear
        orderCount
        orderCountYear
        orderLastDate
        links @skip(if: $skipExport) {
          title
          url
        }
      }
      totalCount
    }
  }
`);
